import { InputLabel, styled } from "@mui/material";
import { gray } from "configs/colors";
import { lineHeight, rem } from "utils";

export const Label = styled(InputLabel)(() => ({
  fontSize: rem(14),
  lineHeight: lineHeight(20),
  fontWeight: 500,
  maxWidth: "unset",
  position: "relative",
  color: gray[700],
  marginBlockStart: 0, // For "p" element
  marginBlockEnd: 0, // For "p" element
}));
